import { sessionListSearchValueAtom } from '@/atoms/sideNavAtoms';
import { IS_SIDEBAR_PANEL_ENABLED } from '@/components/constants/flags';
import { OfflineGatedTooltip } from '@/components/offline-recording/offline-gated-tooltip';
import { useOfflineGating } from '@/hooks/desktop/useOfflineGating';
import { cn } from '@/lib/cn';
import { Button } from '@heidi/design-system/button';
import { useAtom, useAtomValue } from 'jotai';
import { isEmpty } from 'lodash-es';
import { Search } from 'lucide-react';
import { isSessionSearchBarOpenAtom } from '../search-bar.atoms';

export const SearchButton = () => {
  const [isSessionSearchBarOpen, setIsSessionSearchBarOpen] = useAtom(
    isSessionSearchBarOpenAtom
  );
  const sessionListSearchValue = useAtomValue(sessionListSearchValueAtom);
  const isSidebarPanelEnabled = IS_SIDEBAR_PANEL_ENABLED();
  const { shouldGateControls: isOfflineGated } = useOfflineGating();

  const button = (
    <Button
      iconOnly
      data-testid="session-list-search-button"
      size="xxs"
      variant={isSidebarPanelEnabled ? 'panel_ghost' : 'ghost'}
      disabled={isOfflineGated}
      data-active={
        isSidebarPanelEnabled
          ? !isEmpty(sessionListSearchValue) || isSessionSearchBarOpen
          : undefined
      }
      className={
        !isSidebarPanelEnabled
          ? cn(
              'text-text-secondary',
              !isEmpty(sessionListSearchValue) &&
                'bg-surface-selected text-text-active hover:bg-surface-selected-hover hover:text-text-active',
              isSessionSearchBarOpen && 'bg-background-secondary text-text-primary'
            )
          : undefined
      }
      onClick={() => setIsSessionSearchBarOpen(!isSessionSearchBarOpen)}
      aria-label="Toggle session search input visibility"
    >
      <Search aria-hidden="true" />
    </Button>
  );

  if (!isOfflineGated) return button;

  return <OfflineGatedTooltip isOfflineGated>{button}</OfflineGatedTooltip>;
};
